export interface CartItem {
  id: number;
  name: string;
  price: number;
  quantity: number;
  image: string;
}

export interface AddToCartResult {
  success: boolean;
  message?: string;
  item?: CartItem;
}

export const getCart = (): CartItem[] => {
  const cart = localStorage.getItem('cart');
  return cart ? JSON.parse(cart) : [];
};

export const addToCart = (
  product: { id: number; name: string; price: number; image: string }, 
  quantity: number = 1,
  maxStock?: number
): AddToCartResult => {
  const cart = getCart();
  const existingItem = cart.find(item => item.id === product.id);
  
  const currentQuantity = existingItem ? existingItem.quantity : 0;
  const newQuantity = currentQuantity + quantity;
  
  // Check stock limit
  if (maxStock !== undefined && newQuantity > maxStock) {
    if (maxStock === 0) {
      return {
        success: false,
        message: 'Ce produit est épuisé'
      };
    }
    return {
      success: false,
      message: `Seulement ${maxStock} unité${maxStock > 1 ? 's' : ''} disponible${maxStock > 1 ? 's' : ''} en stock`
    };
  }
  
  if (existingItem) {
    existingItem.quantity = newQuantity;
  } else {
    cart.push({ ...product, quantity });
  }
  
  localStorage.setItem('cart', JSON.stringify(cart));
  window.dispatchEvent(new Event('cartUpdated'));
  
  const updatedItem = cart.find(item => item.id === product.id);
  return {
    success: true,
    item: updatedItem
  };
};

export const updateCartItemQuantity = (id: number, quantity: number, maxStock?: number) => {
  const cart = getCart();
  const item = cart.find(item => item.id === id);
  
  if (item) {
    // Check stock limit
    if (maxStock !== undefined && quantity > maxStock) {
      return {
        success: false,
        message: `Stock maximum atteint (${maxStock} unité${maxStock > 1 ? 's' : ''})`
      };
    }
    
    item.quantity = quantity;
    if (item.quantity <= 0) {
      removeFromCart(id);
      return { success: true };
    }
    localStorage.setItem('cart', JSON.stringify(cart));
    window.dispatchEvent(new Event('cartUpdated'));
    return { success: true };
  }
  return { success: false };
};

export const removeFromCart = (id: number) => {
  const cart = getCart();
  const updatedCart = cart.filter(item => item.id !== id);
  localStorage.setItem('cart', JSON.stringify(updatedCart));
  window.dispatchEvent(new Event('cartUpdated'));
};

export const clearCart = () => {
  localStorage.removeItem('cart');
  window.dispatchEvent(new Event('cartUpdated'));
};

export const getCartTotal = (): number => {
  const cart = getCart();
  return cart.reduce((total, item) => total + (item.price * item.quantity), 0);
};

export const getCartCount = (): number => {
  const cart = getCart();
  return cart.reduce((count, item) => count + item.quantity, 0);
};
